import { FormWrapper } from '../../../../../theme/default/base'

export const PricingCompareForm = () => {
  return <FormWrapper></FormWrapper>
}
